var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptimizedTargeting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AY-Illu-Targeting"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.22804 73.1695C9.22804 87.8731 15.069 101.974 25.466 112.371C35.8631 122.769 49.9644 128.609 64.668 128.609C79.3717 128.609 93.473 122.769 103.87 112.371C114.267 101.974 120.108 87.8731 120.108 73.1695C120.108 65.889 118.674 58.6798 115.888 51.9535C113.102 45.2272 109.018 39.1156 103.87 33.9675C98.722 28.8194 92.6103 24.7357 85.884 21.9496C79.1577 19.1635 71.9485 17.7295 64.668 17.7295C57.3876 17.7295 50.1784 19.1635 43.4521 21.9496C36.7258 24.7357 30.6141 28.8194 25.466 33.9675C20.318 39.1156 16.2343 45.2272 13.4482 51.9535C10.662 58.6798 9.22804 65.889 9.22804 73.1695Z",
    fill: "#F7EDF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.5475 114.004C32.5475 114.481 33.325 114.953 34.8355 115.393C36.3459 115.833 38.5599 116.234 41.3509 116.571C44.142 116.908 47.4554 117.175 51.1021 117.358C54.7487 117.54 58.6572 117.634 62.6043 117.634C66.5514 117.634 70.4599 117.54 74.1065 117.358C77.7532 117.175 81.0666 116.908 83.8577 116.571C86.6487 116.234 88.8627 115.833 90.3732 115.393C91.8837 114.953 92.6611 114.481 92.6611 114.004C92.6611 113.041 89.4944 112.118 83.8577 111.437C78.2209 110.756 70.5759 110.374 62.6043 110.374C54.6328 110.374 46.9877 110.756 41.3509 111.437C35.7142 112.118 32.5475 113.041 32.5475 114.004Z",
    fill: "#852E62",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.7803 19.1336C34.7803 17.0795 35.5963 15.1096 37.0488 13.6571C38.5013 12.2047 40.4712 11.3887 42.5253 11.3887H82.6861C83.7031 11.3885 84.7103 11.5887 85.6499 11.9779C86.5896 12.3671 87.4434 12.9376 88.1625 13.6568C88.8816 14.376 89.452 15.2299 89.841 16.1697C90.23 17.1094 90.43 18.1166 90.4296 19.1336V105.265C90.4296 106.282 90.2293 107.289 89.8402 108.228C89.451 109.168 88.8806 110.021 88.1615 110.74C87.4424 111.459 86.5888 112.029 85.6493 112.418C84.7098 112.807 83.7029 113.008 82.6861 113.007H42.5239C40.4702 113.007 38.5006 112.192 37.0484 110.739C35.5962 109.287 34.7803 107.318 34.7803 105.264V19.1336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.7803 19.1336C34.7803 17.0795 35.5963 15.1096 37.0488 13.6571C38.5013 12.2047 40.4712 11.3887 42.5253 11.3887H82.6861C83.7031 11.3885 84.7103 11.5887 85.6499 11.9779C86.5896 12.3671 87.4434 12.9376 88.1625 13.6568C88.8816 14.376 89.452 15.2299 89.841 16.1697C90.23 17.1094 90.43 18.1166 90.4296 19.1336V105.265C90.4296 106.282 90.2293 107.289 89.8402 108.228C89.451 109.168 88.8806 110.021 88.1615 110.74C87.4424 111.459 86.5888 112.029 85.6493 112.418C84.7098 112.807 83.7029 113.008 82.6861 113.007H42.5239C40.4702 113.007 38.5006 112.192 37.0484 110.739C35.5962 109.287 34.7803 107.318 34.7803 105.264V19.1336Z",
    stroke: "#5E0A3C",
    strokeWidth: 1.24444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M39.6203 25.9072H85.5911V97.2835H39.6203V25.9072Z",
    fill: "#F7EDF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M39.6203 25.9072H85.5911V97.2835H39.6203V25.9072Z",
    stroke: "#5E0A3C",
    strokeWidth: 1.24444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M60.1857 18.6498L73.4927 18.6484",
    stroke: "#5E0A3C",
    strokeWidth: 1.24444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M54.7845 18.6483C54.7848 19.016 54.676 19.3755 54.4719 19.6814C54.2677 19.9872 53.9775 20.2257 53.6378 20.3665C53.2981 20.5074 52.9243 20.5443 52.5636 20.4726C52.203 20.401 51.8717 20.2239 51.6116 19.9639C51.3516 19.7039 51.1746 19.3726 51.1029 19.0119C51.0312 18.6512 51.0682 18.2774 51.209 17.9377C51.3498 17.5981 51.5883 17.3078 51.8941 17.1037C52.2 16.8996 52.5595 16.7907 52.9273 16.791C53.1712 16.7908 53.4128 16.8387 53.6382 16.932C53.8636 17.0253 54.0684 17.1621 54.2409 17.3346C54.4134 17.5071 54.5502 17.7119 54.6435 17.9373C54.7368 18.1627 54.7847 18.4043 54.7845 18.6483Z",
    fill: "#5E0A3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M58.3701 105.146C58.3701 106.269 58.8162 107.346 59.6103 108.14C60.4043 108.934 61.4813 109.381 62.6043 109.381C63.7273 109.381 64.8043 108.934 65.5984 108.14C66.3924 107.346 66.8385 106.269 66.8385 105.146C66.8385 104.023 66.3924 102.946 65.5984 102.152C64.8043 101.358 63.7273 100.912 62.6043 100.912C61.4813 100.912 60.4043 101.358 59.6103 102.152C58.8162 102.946 58.3701 104.023 58.3701 105.146Z",
    fill: "white",
    stroke: "#5E0A3C",
    strokeWidth: 1.24444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M44.0984 61.8375C44.0984 66.7635 46.0553 71.4878 49.5386 74.9711C53.0218 78.4544 57.7462 80.4112 62.6722 80.4112C67.5983 80.4112 72.3226 78.4544 75.8059 74.9711C79.2891 71.4878 81.246 66.7635 81.246 61.8375C81.246 56.9114 79.2891 52.1871 75.8059 48.7038C72.3226 45.2205 67.5983 43.2637 62.6722 43.2637C57.7462 43.2637 53.0218 45.2205 49.5386 48.7038C46.0553 52.1871 44.0984 56.9114 44.0984 61.8375Z",
    fill: "#EB9DCB",
    stroke: "#5E0A3C",
    strokeWidth: 1.24444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M50.2897 61.8376C50.2897 63.4637 50.61 65.0739 51.2323 66.5762C51.8546 68.0785 52.7666 69.4435 53.9165 70.5934C55.0663 71.7432 56.4313 72.6553 57.9337 73.2776C59.436 73.8998 61.0461 74.2201 62.6722 74.2201C64.2983 74.2201 65.9085 73.8998 67.4108 73.2776C68.9131 72.6553 70.2782 71.7432 71.428 70.5934C72.5778 69.4435 73.4899 68.0785 74.1122 66.5762C74.7345 65.0739 75.0548 63.4637 75.0548 61.8376C75.0548 60.2115 74.7345 58.6013 74.1122 57.099C73.4899 55.5967 72.5778 54.2317 71.428 53.0818C70.2782 51.932 68.9131 51.0199 67.4108 50.3976C65.9085 49.7754 64.2983 49.4551 62.6722 49.4551C61.0461 49.4551 59.436 49.7754 57.9337 50.3976C56.4313 51.0199 55.0663 51.932 53.9165 53.0818C52.7666 54.2317 51.8546 55.5967 51.2323 57.099C50.61 58.6013 50.2897 60.2115 50.2897 61.8376Z",
    fill: "white",
    stroke: "#5E0A3C",
    strokeWidth: 1.24444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M56.4809 61.8377C56.4809 63.4798 57.1332 65.0545 58.2943 66.2156C59.4554 67.3767 61.0302 68.029 62.6722 68.029C64.3142 68.029 65.889 67.3767 67.0501 66.2156C68.2112 65.0545 68.8635 63.4798 68.8635 61.8377C68.8635 60.1957 68.2112 58.621 67.0501 57.4599C65.889 56.2988 64.3142 55.6465 62.6722 55.6465C61.0302 55.6465 59.4554 56.2988 58.2943 57.4599C57.1332 58.621 56.4809 60.1957 56.4809 61.8377Z",
    fill: "#EB9DCB",
    stroke: "#5E0A3C",
    strokeWidth: 1.24444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M117.766 30.0081C114.339 31.4335 111.232 33.5284 108.625 36.1702C106.019 38.8119 103.966 41.9473 102.586 45.3927C109.568 48.1888 117.362 48.1704 124.331 45.3414L130.779 42.7274L124.403 36.3518L124.188 27.3428L117.766 30.0081Z",
    fill: "#EB9DCB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M124.402 36.3488L124.187 27.3398L117.766 30.0107C114.339 31.4361 111.232 33.531 108.625 36.1728C106.019 38.8145 103.966 41.9499 102.586 45.3953L124.402 36.3488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M117.766 30.0081C114.339 31.4335 111.232 33.5284 108.625 36.1702C106.019 38.8119 103.966 41.9473 102.586 45.3927C109.568 48.1888 117.362 48.1704 124.331 45.3414L130.779 42.7274L124.403 36.3518L124.188 27.3428L117.766 30.0081Z",
    stroke: "#5E0A3C",
    strokeWidth: 1.24444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M124.402 36.3496L62.8676 61.8381",
    stroke: "#5E0A3C",
    strokeWidth: 1.24444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimizedTargeting);
export default __webpack_public_path__ + "static/media/optimized-targeting.c05ced4ad90cbdce6f0fcf9f3fff8846.svg";
export { ForwardRef as ReactComponent };